<div id="app-container" class="app-container">

    <div ref:container class="bespoke-container {{$direction}} chapter-{{$current_chapter}} bespoke-container-active">
        
        <Chapter ref:intro name="intro" slides={{$intro}} />
        <Chapter ref:izerman name="izerman" slides={{$izerman}} />
        <Chapter ref:julia name="julia" slides={{$julia}} />
        <Chapter ref:wilmer name="wilmer" slides={{$wilmer}} />

    </div>

    <ChapterIndex />

    <div class="navbar">
        <h6 class="navbar__title">The Last Generation</h6>
        <div class="navbar__sound {{ $muted ? 'muted' : 'unmuted' }}" on:click="mute()"></div>
        <ul class="navbar__social">
            <li class="navbar__social-item facebook">
                <a target="_blank" rel="noopener" href="http://www.facebook.com/sharer/sharer.php?u={{ BASE_URL }}">Facebook</a>
            </li>
            <li class="navbar__social-item twitter">
                <a target="_blank" rel="noopener" href="https://twitter.com/intent/tweet?url={{ BASE_URL }}&text={{ encodeURIComponent($title) }}&via=frontlinepbs">Twitter</a>
            </li>
        </ul>
    </div>
</div>

<Media ref:media query={{ json2mq({ orientation: 'portrait', maxWidth: +$mobile_max_width || 800 }) }}>
    <ForceLandscape />
</Media>

<script>
import { Howler } from 'howler'
import * as music from './music'
import deck from './_deck'

import Chapter from './Chapter.html'
import ChapterIndex from './ChapterIndex.html'
import Media from './Media.html'
import ForceLandscape from './ForceLandscape.html'

import { pauseMedia, triggerIndexVideo, setHintTimeout, clearHintTimeout, noop } from './helpers'

import json2mq from 'json2mq'

export default {

	components: {
        Chapter,
        ChapterIndex,
        ForceLandscape,
        Media,
    },

    data() {
        return {
            BASE_URL: window.location.href,
        }
    },

    oncreate() {
        this.observers = [];

        this.observers.push(this.store.observe('slides', () => {
            this.updateDeck();
            if (this.store.get('cover_active')) this.deck.freeze();
        }, {defer: true}));

        this.observers.push(this.store.observe('cover_active', cover_active => {
            if (!cover_active) {
                this.deck.unfreeze();
                this.store.set({ current_slide: 0 });
                setHintTimeout(this.store.get('scroll_hint_delay'));
            }
        }));

        this.observers.push(this.store.observe('modal_active', modal_active => {
            if (modal_active) { 
                this.deck.freeze();
            } else {
                this.deck.unfreeze();
            }
        }));

        this.observers.push(this.store.observe('current_chapter', chapter => {
            this.store.set({ bullet: [0, 0] });
        }));

        this.observers.push(this.store.observe('index_active', index_active => {
            if (index_active) {
                if ( !store.get('isMobile').any ) triggerIndexVideo();
            } else {
                if (this.deck) this.deck.slide(this.store.get('current_slide'));
            }
        }, {defer: true}));

        // debugging
        this.music = music;
    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel()
        }
    },

    methods: {

        mute() {
            let muted = store.get('muted');
            store.set({ muted: !muted });
            Howler.mute(!muted);
        },

        chapter(chapter) {
            store.set({ current_chapter: chapter, current_slide: 0 });   
        },

        updateDeck() {
            if (this.deck) {
                this.deck.destroy();
            }

            this.store.deck = this.deck = deck({ parent: '.bespoke-wrapper', slides: '.bespoke-slide' });

            this.deck.chapter = this.store.get('current_chapter');

            this.deck.on('activate', e => {
                if(this.store.get('cover_active') || this.store.get('index_active')) return false;
                const update = { current_slide: e.index };

                // reset bullet count on bullet-less slides
                if (!this.deck.bullet(e.index).length) {
                    update.bullet = [e.index, 0];
                }

                this.store.set(update);

                clearHintTimeout();

                if (this.store.get('scroll_hint')) setHintTimeout(this.store.get('scroll_hint_delay'));
            });

            this.deck.on('bullet', e => {
                this.store.set({ bullet: [e.slideIndex, e.bulletIndex] });
                clearHintTimeout();
                if (this.store.get('scroll_hint')) setHintTimeout();
            });

            this.deck.on('prev', e => {
                this.store.set({ direction: 'up' });
            });

            this.deck.on('next', e => {
                if (this.store.get('cover_active') || this.store.get('index_active')) return false;

                this.store.set({ direction: 'down' });
                
                if ( ( e.index == this.deck.slides.length - 1) && this.store.get('next_chapter') ) {
                    this.store.set({ 
                        index_active: true, 
                        //current_chapter: this.store.get('next_chapter'), 
                        index_chapter: this.store.get('next_chapter'), 
                        //current_slide: 0 
                    });
                    
                    //if ( !store.get('isMobile').any ) triggerIndexVideo();
                }
            });

            // debugging
            //this.deck.on('freeze', e => console.log('frozen'));
            //this.deck.on('unfreeze', e => console.log('unfrozen'));

            return this.deck;
        },

        index() {
            this.store.set({ index_active: true });   
        },

        reset() {
            this.store.set({ current_chapter: 'intro', current_slide: 0, index_active: false });
        }

    },

    helpers: {
        json2mq,
    }
}
</script>
